import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap";
import NewsCard from "../NewsCard";
import Slider from "react-slick";

import "./News.scss";


const OfficeNews = ({blogs}) => {

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const [icon, setIcon] = useState(false);

    //console.log("blogs ==>", blogs)

    return (
        <>
            <section className={"news office_bg"}>
                <Container>
                    <Row>
                        <Col>
                            <h2>{'News & Insights'}</h2>

                            {blogs?.length > 0 && 
                                <Slider {...settings}>
                                    {blogs?.map((News, index) => (
                                        <NewsCard key={index} NewsList={News} />
                                    ))}
                                </Slider>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default OfficeNews;